import React from 'react';
import './LocationDisplay.css';
import PropTypes from 'prop-types';

const LocationDisplay = ({ city, state, country }) => {
  if (!city && !state && !country) {
    return <span className="location-no-data">No location</span>;
  }
  return (
    <div className="location-container">
      {city && <div className="location-city">{city}</div>}
      <div className="location-badges-container">
        {state && <span className="location-state-badge">{state}</span>}
        {country && <span className="location-country-badge">{country}</span>}
      </div>
    </div>
  );
};

LocationDisplay.propTypes = {
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string
};

export default LocationDisplay;
